'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'

export default function Searchbar() {
	const [searchQuery, setSearchQuery] = useState('')
	const router = useRouter()

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSearchQuery(event.target.value)
	}

	const handleKeyDown = async (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			router.push(`/list?search=${searchQuery}`)
		}
	}

	return (
		<input 
			className="px-5 py-2 rounded-full border-slate-200 border-solid border text-sm grow w-full lg:w-auto" 
			type="text" 
			placeholder="Rechercher un article"
			value={searchQuery}
			onChange={handleInputChange}
			onKeyDown={handleKeyDown}
		/>
	)
}
